export default {
      id: "query_builder-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#query_builder",
      toString: function () {
        return this.url;
      }
    }